import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrBE: CultureInfo = {
  name: 'fr-BE',
  displayName: 'French (Belgium)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-BE',
  parent: CultureInfoFr
};
